var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03009 1.75746C4.14139 1.3123 4.54137 1 5.00024 1H19.0002C19.4591 1 19.8591 1.3123 19.9704 1.75746L21.9704 9.75746C22.1043 10.2933 21.7786 10.8362 21.2428 10.9701C20.707 11.1041 20.164 10.7783 20.0301 10.2425L18.2195 3H5.78101L3.97038 10.2425C3.83643 10.7783 3.2935 11.1041 2.7577 10.9701C2.22191 10.8362 1.89615 10.2933 2.03009 9.75746L4.03009 1.75746Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 17C3.55228 17 4 17.4477 4 18V21H6V18C6 17.4477 6.44772 17 7 17C7.55228 17 8 17.4477 8 18V22C8 22.5523 7.55228 23 7 23H3C2.44772 23 2 22.5523 2 22V18C2 17.4477 2.44772 17 3 17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 17C17.5523 17 18 17.4477 18 18V21H20V18C20 17.4477 20.4477 17 21 17C21.5523 17 22 17.4477 22 18V22C22 22.5523 21.5523 23 21 23H17C16.4477 23 16 22.5523 16 22V18C16 17.4477 16.4477 17 17 17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29289 9.29289C2.48043 9.10536 2.73478 9 3 9H21C21.2652 9 21.5196 9.10536 21.7071 9.29289L23.7071 11.2929C23.8946 11.4804 24 11.7348 24 12V18C24 18.5523 23.5523 19 23 19H1C0.447715 19 0 18.5523 0 18V12C0 11.7348 0.105357 11.4804 0.292893 11.2929L2.29289 9.29289ZM3.41421 11L2 12.4142V17H22V12.4142L20.5858 11H3.41421Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14C4 13.4477 4.44772 13 5 13H7C7.55228 13 8 13.4477 8 14C8 14.5523 7.55228 15 7 15H5C4.44772 15 4 14.5523 4 14Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14C16 13.4477 16.4477 13 17 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H17C16.4477 15 16 14.5523 16 14Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.2ae4427583e00f3dd16caa62ac701481.svg";
export { ForwardRef as ReactComponent };